import {remCalc} from '../../_utils'

export default {
    baseStyle: ({
        isSingleShipmentOrder,
        isReturnFlow,
        returnSettings,
    }: {
        isSingleShipmentOrder: boolean
        isReturnFlow: boolean
        returnSettings?: string
    }) => ({
        guestOrderContainer: {
            gap: 0,
            w: '100%',
            maxW: remCalc(1400),
            margin: 'auto',
            padding: {base: remCalc(20), lg: remCalc(40)},
        },
        goBackToOrderHistory: {
            fontWeight: 'normal',
            textStyle: 'body-small',
            color: 'text.tertiary',
            textDecoration: 'underline',
            justifyContent: 'flex-start',
            pt: remCalc(24),
        },
        header: {
            textStyle: 'body-xlarge',
            py: remCalc(16),
            fontWeight: 'medium',
            display: 'flex',
            flexDirection: 'column',
            gap: remCalc(8),
        },
        wrapper: {
            display: {base: 'grid', md: 'flex'},
            gridTemplateColumns: {
                base: 'repeat(2, 1fr)',
                md: 'unset',
            },
            position: 'relative',
            gap: {base: 'unset', md: remCalc(24)},
            rowGap: {base: remCalc(24), md: 'unset'},
            columnGap: {base: remCalc(8), md: 'unset'},
            layerStyle: 'cardBordered',
            w: '100%',
            alignItems: 'center',
            borderWidth: remCalc(1),
            borderRadius: remCalc(10),
            borderColor: 'border.light',
            pt: {base: remCalc(16), lg: remCalc(24)},
            px: {base: remCalc(29), lg: remCalc(24)},
            pb: {base: remCalc(16), lg: remCalc(24)},
            flexWrap: {
                base: 'wrap',
                md: 'nowrap',
            },
            justifyContent: 'space-between',
            mb: {base: remCalc(24), md: remCalc(40)},
        },
        firstColumn: {
            display: {base: 'grid', md: 'flex'},
            flexBasis: {base: 'unset', md: remCalc(139)},
            gridColumn: {base: 1, md: 'unset'},
            gridTemplateColumns: {base: `minmax(${remCalc(139)}, 1fr)`, md: 'unset'},
        },
        secondColumn: {
            display: {base: 'grid', md: 'flex'},
            flexBasis: {base: 'unset', md: remCalc(139)},
            gridColumn: {base: 2, md: 'unset'},
            gridTemplateColumns: {base: `minmax(${remCalc(139)}, 1fr)`, md: 'unset'},
        },
        gaps: {
            gap: {base: remCalc(8), md: remCalc(16)},
        },
        bodyMedium: {
            textStyle: 'body-medium',
            color: 'text.default',
        },
        detailsContainerDesktop: {
            display: {base: 'none', md: 'flex'},
            flex: '0 0 auto',
            height: '100%',
        },
        detailsContainerMobile: {
            display: {base: 'block', md: 'none'},
            gridColumn: {base: '1 / -1', md: '1 / -1'},
            height: '100%',
            // mt: remCalc(20),
        },
        detailsLink: {
            alignItems: {base: 'flex-start', md: 'flex-end'},
            height: '100%',
        },
        formCancellationContainer: {
            gap: {base: remCalc(16), md: remCalc(24)},
            flexDirection: {base: 'column', md: 'row'},
        },
        formCancellationStack: {
            w: {base: 'auto', md: remCalc(351)},
            gap: remCalc(24),
        },
        formCancellationSelectText: {
            textStyle: 'body-xsmall',
            fontSize: remCalc(12),
            fontWeight: 'normal',
            color: 'text.secondary',
        },
        confirmCancellationText: {
            textStyle: 'head-xlarge',
            color: 'text.default',
            fontWeight: 'medium',
            pt: {base: remCalc(16), md: remCalc(24)},
            pb: remCalc(24),
            borderBottom: 'small',
            borderStyle: 'solid',
            borderColor: 'border.light',
        },
        confirmationDate: {
            textStyle: 'head-xsmall',
            color: 'text.default',
            fontWeight: 'medium',
        },
        cancellationStack: {
            gap: remCalc(16),
            pt: {base: remCalc(16), md: remCalc(24)},
            pb: {base: remCalc(24), md: remCalc(40)},
        },
        priceContainer: {
            backgroundColor: 'background.light',
            py: {base: remCalc(16), md: remCalc(24)},
            px: remCalc(24),
            justifyContent: isReturnFlow ? 'flex-end' : 'space-between',
            flexDirection: {base: 'column', md: 'row', lg: 'row'},
            alignItems: isReturnFlow ? 'flex-end' : {base: 'center', md: 'flex-start'},
            gap: remCalc(16),
            borderBottomLeftRadius: 'inherit',
            borderBottomRightRadius: 'inherit',
        },
        priceChild: {
            flexDirection: {base: 'row', md: 'column'},
            justifyContent: {base: 'space-between'},
            flexBasis: isReturnFlow ? 'auto' : {lg: remCalc(180)},
            gap: {md: remCalc(16)},
            alignItems: isReturnFlow ? 'flex-end' : {base: 'center', md: 'flex-start'},
            w: '100%',
        },
        priceTitle: {
            fontWeight: 'normal',
            textStyle: 'body-medium',
            color: 'text.default',
        },
        priceNumber: {
            fontWeight: 'bold',
            textStyle: 'body-medium',
            color: 'text.default',
        },
        shipmentWrapper: {
            position: 'relative',
            gap: isSingleShipmentOrder ? remCalc(0) : 'unset',
            pY: 0,
        },
        orderNumberHeader: {
            textStyle: 'head-medium',
            color: 'text.default',
            fontWeight: 'medium',
            borderBottom: 'small',
            borderStyle: 'solid',
            borderColor: 'border.light',
            pt: {base: remCalc(16), md: remCalc(24)},
            pb: remCalc(24),
            wordBreak: 'break-word',
        },
        cancellationHeader: {
            textStyle: 'head-medium',
            color: 'text.default',
            fontWeight: 'medium',
        },
        stackWrapper: {
            borderWidth: remCalc(1),
            borderRadius: 'lg',
            borderColor: 'border.light',
            p: remCalc(24),
            gap: {base: remCalc(24), md: remCalc(40)}, // Set mobile gap to 24, others unchanged
            pt: {base: remCalc(16), md: remCalc(24)}, // Set mobile top padding to 16, others unchanged
            pb: {base: remCalc(16), md: remCalc(24)}, // Set mobile bottom padding to 16, others unchanged
            mt: returnSettings === 'No return' ? remCalc(24) : {base: remCalc(24), md: remCalc(40)},
            mb: {base: remCalc(16), md: remCalc(24)},
        },
        tertiaryButton: {
            color: 'text.tertiary',
            textStyle: 'body-medium',
            textDecoration: 'underline',
            fontWeight: 'bold',
        },
        tertiaryButtonLine: {
            color: 'text.tertiary',
            textStyle: 'body-medium',
            textDecoration: 'underline',
            fontWeight: 'bold',
        },
        secondaryButtonOrder: {
            _hover: {
                textDecoration: 'none',
                border: 'none',
                color: 'button.text.secondary-hover',
                bg: 'button.background.primary-default',
            },
        },
        singleShipmentContainer: {
            borderTopRadius: 'inherit',
            flexDirection: 'column',
        },
        paddingList: {
            paddingLeft: remCalc(24),
        },
        borderWrapper: {
            borderWidth: remCalc(1),
            borderRadius: 'lg',
            borderStyle: 'solid',
            borderColor: 'border.light',
        },
        multiShipmentContainer: {
            flexDirection: 'column',
            gap: remCalc(16),
            py: {base: remCalc(24), md: remCalc(40)},
            px: {base: remCalc(16), md: remCalc(24)},
            borderBottom: 'small',
            borderStyle: 'solid',
            borderColor: 'border.light',
        },
        multiShipmentContainerNoGap: {
            flexDirection: 'column',
        },
        shipmentSequenceContainer: {
            gap: {base: remCalc(24), md: remCalc(30)},
            // pb: remCalc(16),
            flexDirection: {base: 'column', md: 'row'},
        },
        sequenceTextTitle: {
            fontSize: {base: remCalc(24), md: remCalc(24)},
            lineHeight: {base: remCalc(24), md: remCalc(26)},
            fontWeight: 'medium',
            color: 'text.default',
        },
        orderDetailsReturnContainer: {
            flexDir: 'column',
            backgroundColor: 'background.light',
            px: remCalc(24),
        },
        printButton: {
            maxWidth: ['unset', 'unset', 'unset', remCalc(279)],
            width: '100%',
        },
        orderDetailsReturnHeader: {
            flexDir: 'column',
            gap: [remCalc(8), remCalc(8), remCalc(8), remCalc(16)],
            pt: remCalc(20),
        },
        returnNumberContainer: {
            gap: [remCalc(8), remCalc(8), remCalc(8), remCalc(30)],
            flexDirection: ['column', 'column', 'column', 'row'],
        },
        orderHistoryHeader: {
            textStyle: 'head-xlarge',
            py: remCalc(24),
            borderBottom: 'small',
            borderStyle: 'solid',
            borderColor: 'border.light',
            fontWeight: 'medium',
        },
        orderDetailsReturnBox: {
            justifyContent: 'space-between',
            alignItems: 'center',
            gap: [remCalc(12), remCalc(12), remCalc(12), remCalc(16)],
            alignSelf: ['stretch', 'stretch', 'stretch', 'unset'],
            flexDirection: ['column', 'column', 'column', 'row'],
        },
        returnOrderFormContainer: {
            flexDir: ['column', 'column', 'column', 'row'],
            gap: [remCalc(8), remCalc(8), remCalc(8), remCalc(24)],
            justifyContent: 'space-between',
            borderBottom: 'small',
            borderStyle: 'solid',
            borderColor: 'border.light',
        },
        returnOrderSelectContainer: {
            pt: [0, 0, 0, remCalc(24)],
            mb: [remCalc(16), remCalc(16), remCalc(16), 0],
        },
        returnOrderSelect: {
            width: ['100%', '100%', '100%', '100%', remCalc(390)],
            fontSize: remCalc(12),
        },
        returnOrderItemContainer: {
            gap: [remCalc(8), remCalc(8), remCalc(8), remCalc(24)],
        },
        orderDetailsReturnBottomWrapper: {
            pb: remCalc(20),
            justifyContent: 'space-between',
            alignItems: 'center',
            gap: [remCalc(12), remCalc(12), remCalc(12), 0],
            alignSelf: ['stretch', 'stretch', 'stretch', 'unset'],
            flexDirection: ['column', 'column', 'column', 'row'],
        },
        orderDetailsNonReturnableItemsContainer: {
            flexDir: 'column',
            backgroundColor: 'background.default',
            px: remCalc(24),
        },
        returnItemContainer: {
            gap: remCalc(24),
            px: remCalc(24),
        },
        orderReturnHeaderContainer: {
            gap: remCalc(40),
            pb: remCalc(24),
        },
        orderReturnHeaderTitleDescription: {
            flexDirection: 'column',
            gap: remCalc(24),
            py: remCalc(24),
            pt: {base: remCalc(16), md: remCalc(24)},
            borderBottom: 'small',
            borderStyle: 'solid',
            borderColor: 'border.light',
        },
        orderReturnHeaderTitle: {
            textStyle: 'head-xlarge',
            fontWeight: 'medium',
        },
        orderReturnHeaderNumDateContainer: {
            gap: {base: remCalc(16), lg: remCalc(40)},
            border: 'small',
            borderStyle: 'solid',
            borderColor: 'border.light',
            borderRadius: 'lg',
            p: remCalc(24),
            flexDirection: {base: 'column', lg: 'row'},
        },
        returnModalContainer: {
            maxWidth: [remCalc(343), remCalc(343), remCalc(343), remCalc(689)],
            width: '100%',
            px: remCalc(24),
            paddingTop: [remCalc(24), remCalc(24), remCalc(24), remCalc(40)],
            paddingBottom: [remCalc(8), remCalc(8), remCalc(8), remCalc(16)],
            alignItems: 'flex-start',
        },
        returnModalButton: {
            pt: ['small.base', 'small.sm', 'small.md', 'small.lg'],
            pb: ['medium.base', 'medium.sm', 'medium.md', 'medium.lg'],
            textDecoration: 'underline',
            textStyle: 'body-medium',
            color: 'text.tertiary',
            background: 'none',
            border: 'none',
            pl: 0,
            pr: 0,
            cursor: 'pointer',
        },
        returnModalHeader: {
            justifyContent: 'space-between',
            alignItems: 'flex-end',
            pb: remCalc(16),
            borderBottom: 'small',
            borderStyle: 'solid',
            borderColor: 'border.dark',
        },
        returnModalTitle: {
            textStyle: 'body-large',
            color: 'text.default',
            fontWeight: 'normal',
        },
        returnModalStep: {
            textStyle: 'body-medium',
            color: 'text.default',
            fontWeight: 'normal',
        },
        returnModalStepsContainer: {
            gap: remCalc(16),
            paddingBottom: [remCalc(16), remCalc(16), remCalc(16), remCalc(24)],
        },
        returnModalStepIcon: {
            width: remCalc(40),
            height: remCalc(40),
            fill: 'background.default',
            color: 'border.dark',
        },
        returnModalDummyBox: {
            pt: ['small.base', 'small.sm', 'small.md', 'small.lg'],
        },
        returnFormWarningTitle: {
            textStyle: 'body-xsmall',
            color: 'text.default',
            fontWeight: 'bold',
        },
        returnFormWarningDescription: {
            textStyle: 'body-xsmall',
            color: 'text.default',
            fontWeight: 'normal',
        },
        returnFormWarningContainer: {
            display: 'flex',
            padding: ['small.base', 'small.sm', 'small.md', 'small.lg'],
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: remCalc(16),
            alignSelf: 'stretch',
            backgroundColor: 'background.info',
            borderRadius: remCalc(4),
            mt: [0, 0, 0, remCalc(24)],
            mb: [remCalc(16), remCalc(16), remCalc(16), remCalc(48)],
        },
        returnFormWarningInnerContainer: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: remCalc(8),
            alignSelf: 'stretch',
        },
        returnFormWarningItemAlreadyReturnedContainer: {
            display: 'flex',
            backgroundColor: 'background.info',
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: remCalc(10),
            flex: '1 0 0',
            alignSelf: 'stretch',
            mt: ['unset', 'unset', 'unset', remCalc(48)],
            mb: ['unset', 'unset', 'unset', remCalc(174)],
        },
        returnFormWarningItemAlreadyReturnedInnerContainer: {
            display: 'flex',
            padding: [remCalc(16), remCalc(16), remCalc(16), remCalc(24)],
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: remCalc(16),
            alignSelf: 'stretch',
        },
        returnFormWarningLinkContainer: {
            justifyContent: 'center',
            alignItems: 'center',
        },
        returnModalConfirmationButton: {
            width: '100%',
        },
        returnConfirmationModalDescription: {
            textStyle: 'body-medium',
            color: 'text.default',
            fontWeight: 'normal',
            py: [remCalc(16), remCalc(16), remCalc(16), remCalc(24)],
        },
        expiredReturnContainer: {
            display: 'flex',
            padding: remCalc(24),
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: [remCalc(16), remCalc(16), remCalc(16), remCalc(24)],
            alignSelf: 'stretch',
            borderRadius: remCalc(8),
            background: 'background.light',
        },
        expiredNoReturnContainer: {
            display: 'flex',
            padding: remCalc(24),
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: [remCalc(16), remCalc(16), remCalc(16), remCalc(24)],
            alignSelf: 'stretch',
            borderRadius: remCalc(8),
            background: 'background.light',
            mt: [remCalc(16), remCalc(16), remCalc(16), remCalc(40)],
        },
        expiredReturnLabelContainer: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: remCalc(8),
            alignSelf: 'stretch',
        },
        expiredReturnTitle: {
            textStyle: 'head-xsmall',
            color: 'text.default',
            fontWeight: 'medium',
        },
        expiredReturnDescription: {
            textStyle: 'body-small',
            color: 'text.default',
            fontWeight: 'normal',
        },
        expiredReturnButtonsContainer: {
            display: 'flex',
            alignItems: ['flex-start', 'flex-start', 'flex-start', 'flex-end'],
            gap: remCalc(16),
            alignSelf: 'stretch',
            flexDirection: ['column', 'column', 'column', 'row'],
            justifyContent: ['flex-end', 'flex-end', 'flex-end', 'unset'],
        },
        expiredReturnButton: {
            width: '100%',
            minWidth: remCalc(140),
            maxWidth: ['unset', 'unset', 'unset', remCalc(211)],
        },
        //widget
        widgetWrapper: {
            display: {base: 'flex'},
            flexDirection: {base: 'row'},
            position: 'relative',
            gap: {base: remCalc(16), lg: remCalc(24)},
            layerStyle: 'cardBordered',
            w: '100%',
            alignItems: {base: 'unset', lg: 'center'},
            borderWidth: remCalc(1),
            borderRadius: remCalc(10),
            borderColor: 'border.light',
            py: {base: remCalc(16), lg: remCalc(24)},
            px: {base: remCalc(16), lg: remCalc(24)},
            flexWrap: 'nowrap',
            justifyContent: {base: 'center', md: 'space-between'},
            mb: {base: remCalc(24)},
        },
        orderContainer: {
            display: 'flex',
            flexDirection: 'column',
            gap: remCalc(24),
            width: '100%',
        },
        orderDetails: {
            justifyContent: 'space-between',
            flexDirection: {base: 'column', md: 'row'},
            alignItems: {base: 'flex-start', lg: 'flex-end'},
        },
        widgetHeader: {
            textStyle: {base: 'head-small', lg: 'head-medium'},
            py: {base: 0, lg: remCalc(16)},
            fontWeight: 'medium',
            display: 'flex',
            flexDirection: 'column',
            gap: remCalc(8),
        },
        orderWidgetProductImage: {
            width: {
                lg: remCalc(132),
                md: remCalc(109),
                sm: remCalc(109),
                base: remCalc(109),
            },
            height: {
                lg: remCalc(128),
                md: remCalc(109),
                sm: remCalc(109),
                base: remCalc(109),
            },
        },
        preorderLabel: {
            textStyle: 'body-xsmall',
            fontWeight: 'normal',
            color: 'text.default',
        },
    }),
}
